import { render, staticRenderFns } from "./IconSectionWatching.vue?vue&type=template&id=7ff404e2&"
import script from "./IconSectionWatching.vue?vue&type=script&lang=js&"
export * from "./IconSectionWatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff404e2')) {
      api.createRecord('7ff404e2', component.options)
    } else {
      api.reload('7ff404e2', component.options)
    }
    module.hot.accept("./IconSectionWatching.vue?vue&type=template&id=7ff404e2&", function () {
      api.rerender('7ff404e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionWatching.vue"
export default component.exports